import type { DepositCvusTranslations } from "../interfaces/depositCvus";

export const depositCvusTranslations: DepositCvusTranslations = {
  // Page
  page_title: "Deposit CVUs",
  page_subtitle: "Receiving accounts for Argentine peso deposits (Argentina)",
  why_banner:
    "Without a registered CVU, the organization's deposits in Argentina cannot be attributed or credited.",
  no_org_prompt: "Select an organization to see its CVUs.",

  // Org selector
  org_label: "Organization",
  org_placeholder: "Search organization…",
  org_loading: "Loading organizations…",
  org_empty: "No organizations found.",
  org_error: "We could not load the organizations.",
  org_truncated: "There are more organizations than shown; refine the search by name.",

  // List
  list_title: "Registered CVUs",
  filter_placeholder: "Filter by CVU or note…",
  filter_no_results: "No CVU matches the filter.",
  empty_title: "No CVUs registered",
  empty_description:
    "Register the first receiving account to enable this organization's deposits in Argentina.",
  error_load: "We could not load the organization's CVUs.",
  error_retry: "Retry",
  registered_at: "Registered on",
  note_label: "Note",
  status_active: "Active",
  status_inactive: "Inactive",
  flavor_static: "Static",
  flavor_dynamic: "Dynamic",
  copy_aria: "Copy",
  copy_success: "Copied to clipboard",

  // Register dialog
  button_register: "Register CVU",
  dialog_title: "Register deposit CVU",
  dialog_description: "The receiving account will be linked to the selected organization.",
  dialog_org_label: "Organization",
  dialog_account_label: "CVU",
  dialog_account_placeholder: "0000 0031 0001 0000 0000 01",
  dialog_account_helper: "22 digits, no spaces or dashes.",
  dialog_note_label: "Note (optional)",
  dialog_note_placeholder: "e.g. main receiving CVU",
  dialog_cancel: "Cancel",
  dialog_submit: "Register",
  validation_account: "The CVU must be exactly 22 digits.",
  hint_already_registered: "This CVU is already registered for this organization.",
  toast_registered: "CVU registered",
  toast_already_registered: "This CVU was already registered for the organization",
  error_cross_org:
    "This CVU is already assigned to another organization. A CVU can only be active for one organization at a time.",
  error_no_write_permission: "You do not have permission to register deposit CVUs.",
  error_register: "We could not register the CVU.",

  // Detail drawer
  drawer_title: "CVU detail",
  drawer_section_details: "Details",
  drawer_section_metadata: "Metadata",
  drawer_id: "ID",
  drawer_reference: "Reference",
  drawer_created: "Registered",
  drawer_updated: "Updated",
};
